
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenDataCenterProvider {
    static readonly RETAIL: GenDataCenterProvider = new GenDataCenterProvider('RETAIL');
    static readonly RETAIL_WHOLESALE: GenDataCenterProvider = new GenDataCenterProvider('RETAIL_WHOLESALE');
    static readonly WHOLESALE: GenDataCenterProvider = new GenDataCenterProvider('WHOLESALE');
    static readonly RESELLER: GenDataCenterProvider = new GenDataCenterProvider('RESELLER');
    static readonly INVESTOR: GenDataCenterProvider = new GenDataCenterProvider('INVESTOR');
    static readonly CRYPTO_HOSTING: GenDataCenterProvider = new GenDataCenterProvider('CRYPTO_HOSTING');
    static readonly CRYPTO_MINING: GenDataCenterProvider = new GenDataCenterProvider('CRYPTO_MINING');
    static readonly HOSTING: GenDataCenterProvider = new GenDataCenterProvider('HOSTING');
    static readonly HYPERSCALE: GenDataCenterProvider = new GenDataCenterProvider('HYPERSCALE');
    static readonly POWERED_SHELL: GenDataCenterProvider = new GenDataCenterProvider('POWERED_SHELL');
    static readonly TELCO: GenDataCenterProvider = new GenDataCenterProvider('TELCO');
    static readonly NEOCLOUD: GenDataCenterProvider = new GenDataCenterProvider('NEOCLOUD');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'RETAIL') return GenDataCenterProvider.RETAIL;
        if (name === 'RETAIL_WHOLESALE') return GenDataCenterProvider.RETAIL_WHOLESALE;
        if (name === 'WHOLESALE') return GenDataCenterProvider.WHOLESALE;
        if (name === 'RESELLER') return GenDataCenterProvider.RESELLER;
        if (name === 'INVESTOR') return GenDataCenterProvider.INVESTOR;
        if (name === 'CRYPTO_HOSTING') return GenDataCenterProvider.CRYPTO_HOSTING;
        if (name === 'CRYPTO_MINING') return GenDataCenterProvider.CRYPTO_MINING;
        if (name === 'HOSTING') return GenDataCenterProvider.HOSTING;
        if (name === 'HYPERSCALE') return GenDataCenterProvider.HYPERSCALE;
        if (name === 'POWERED_SHELL') return GenDataCenterProvider.POWERED_SHELL;
        if (name === 'TELCO') return GenDataCenterProvider.TELCO;
        if (name === 'NEOCLOUD') return GenDataCenterProvider.NEOCLOUD;
        throw new Error('Unexpected value for GenDataCenterProvider:' + name);
    }

    static values(): GenDataCenterProvider[] {
        return [
            GenDataCenterProvider.RETAIL,
            GenDataCenterProvider.RETAIL_WHOLESALE,
            GenDataCenterProvider.WHOLESALE,
            GenDataCenterProvider.RESELLER,
            GenDataCenterProvider.INVESTOR,
            GenDataCenterProvider.CRYPTO_HOSTING,
            GenDataCenterProvider.CRYPTO_MINING,
            GenDataCenterProvider.HOSTING,
            GenDataCenterProvider.HYPERSCALE,
            GenDataCenterProvider.POWERED_SHELL,
            GenDataCenterProvider.TELCO,
            GenDataCenterProvider.NEOCLOUD,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

